<template>
  <div class="visualize-data" v-if="data && data.results && data.results.length > 0">
    <div
      v-if="type === 'gauge'"
      ref="chartRef"
      class="chart-container"
      :style="{ width: '100%', height: chartHeight + 'px' }"
    ></div>

    <div
      v-if="type === 'gauge-preview'"
      ref="chartRef"
      class="chart-container"
      :style="{ width: '100%', height: chartHeight + 'px' }"
    ></div>

    <div
      v-if="type === 'gauge-belbin-ddr'"
      ref="chartRef"
      class="chart-container"
      :style="{ width: '100%', height: chartHeight + 'px' }"
    ></div>

    <div
      v-else-if="type === 'radar'"
      ref="chartRef"
      class="chart-container"
      :style="{ width: '100%', height: chartHeight + 'px' }"
    ></div>

    <div
      v-else-if="type === 'radar-norm'"
      ref="chartRef"
      class="chart-container"
      :style="{ width: '100%', height: chartHeight + 'px' }"
    ></div>

    <div
      v-else-if="type === 'benchmark-bar-colored'"
      ref="chartRef"
      class="chart-container"
      :style="{ width: '100%', height: chartHeight + 'px' }"
    ></div>

    <div
      v-else-if="type === 'rainfall'"
      ref="chartRef"
      class="chart-container"
      :style="{ width: '100%', height: chartHeight + 'px' }"
    ></div>

    <div
      v-else-if="type === 'ocai-radar'"
      ref="chartRef"
      class="chart-container"
      :style="{ width: '100%', height: chartHeight + 'px' }"
    ></div>

    <div
      v-else-if="type === 'pie'"
      ref="chartRef"
      class="chart-container"
      :style="{ width: '100%', height: chartHeight + 'px' }"
    ></div>

    <div
      v-else-if="type === 'simple-gauge'"
      ref="chartRef"
      class="chart-container"
      :style="{ width: '100%', height: chartHeight + 'px' }"
    ></div>

    <div
      v-else-if="type === 'big-simple-gauge'"
      ref="chartRef"
      class="chart-container"
      :style="{ width: '100%', height: chartHeight + 'px' }"
    ></div>

    <div
      v-else-if="type === 'benchmark-bar-horizontal'"
      ref="chartRef"
      class="chart-container"
      :style="{ width: '100%', height: chartHeight + 'px' }"
    ></div>

    <div
      v-else-if="type === 'benchmark-bar-horizontal-with-norm'"
      ref="chartRef"
      class="chart-container"
      :style="{ width: '100%', height: chartHeight + 'px' }"
    ></div>

    <!-- Belbin table -->
    <div
      class="chart-container belbin-table-container"
      v-else-if="type === 'belbin-table'"
      style="max-width: 100%"
    >
      <div class="table-wrapper" style="max-width: 100%; overflow-x: auto">
        <h2 class="table-title">{{ title }}</h2>
        <template v-if="data.grouped">
          <table v-if="data?.results && data?.results?.length > 0" style="min-width: 100%">
            <thead class="thead">
              <th v-for="(item, index) in data.results[0]" :key="index">
                <span>{{ shortenLabel(item.calculationValueLabel) }}</span>
              </th>
            </thead>
            <tbody>
              <tr v-for="(row, index) in data.results" :key="index">
                <td v-for="item in row" :key="item.calculationValueLabel">
                  <span
                    :class="returnClassBasedOnRules(item, true)"
                    :data-label="shortenLabel(item.calculationValueLabel)"
                    >{{ Math.ceil( item.calculationResultValue ) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
        <template v-else>
          <table v-if="data?.results && data?.results?.length > 0" style="min-width: 100%">
            <thead class="thead">
              <th>
                <span>{{ shortenLabel(data.results[0].calculationValueLabel) }}</span>
              </th>
            </thead>
            <tbody>
              <tr>
                <td v-for="item in data.results" :key="item.calculationValueLabel">
                  <span
                    :class="returnClassBasedOnRules(item)"
                    :data-label="shortenLabel(item.calculationValueLabel)"
                  >
                    {{ item.calculationResultValue.toFixed(decimalAmount) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>

    <div
      v-else-if="type === 'benchmark-bar'"
      ref="chartRef"
      class="chart-container"
      :style="{ width: '100%', height: chartHeight + 'px' }"
    ></div>

    <div
      v-else-if="type === 'benchmark-bar-with-norm'"
      ref="chartRef"
      class="chart-container"
      :style="{ width: '100%', height: chartHeight + 'px' }"
    ></div>

    <div
      v-else-if="type === 'resilience-bar'"
      ref="chartRef"
      class="chart-container"
      :style="{ width: '100%', height: chartHeight + 'px' }"
    ></div>

    <!-- table table -->
    <div
      class="chart-container"
      :class="extraClass"
      v-else-if="type === 'table'"
      style="max-width: 100%"
    >
      <div class="table-wrapper" style="max-width: 100%; overflow-x: auto">
        <h2 class="table-title">{{ title }}</h2>
        <table v-if="data?.results && data?.results?.length > 0" style="min-width: 100%">
          <thead v-if="tableHead && tableHead.length > 0">
            <th v-for="(item, index) in tableHead" :key="index">
              {{ item }}
            </th>
          </thead>
          <tbody>
            <template
              v-for="(item, index) in data.results"
              :key="index + '_' + item.calculationValueLabel"
            >
              <tr>
                <td>
                  <!-- {{ item.calculationMeta4 }} -->

                  <!-- 5d90d621-143b-48cf-bc17-6686bd1f38d2 ->> OCAI - ORGANISATIECULTUUR -->

                  <!-- <router-link
                      :to="`/results/${item.calculationValueLabel}`"
                      v-if="enableDetailPage && item?.calculationMeta4 !== ''"
                    >
                      <span>{{ item.calculationValueLabel }}</span>
                    </router-link> -->
                  <router-link
                    :to="`/explanation/${item.calculationMeta4}`"
                    class="link label-link"
                    v-if="enableDetailPage && item.calculationMeta4 !== ''"
                  >
                    <span>{{ item.calculationValueLabel }}</span>

                    
                  </router-link>

                  

                  <span v-else>{{ item.calculationValueLabel }}</span>
                </td>
                <td>
                  <router-link
                    :to="`/explanation/${item.calculationMeta4}`"
                    v-if="enableDetailPage && item?.calculationMeta4 !== ''"
                    class="link"
                  >
                    <span :class="returnClassBasedOnRules(item)">{{
                      item.calculationResultValue.toFixed(decimalAmount)
                    }}</span>
                  </router-link>
                  <span v-else :class="returnClassBasedOnRules(item)">{{
                    item.calculationResultValue.toFixed(decimalAmount)
                  }}</span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <!-- expanded table -->
    <div
      class="chart-container expanded-table-container"
      v-else-if="type === 'expanded-table'"
      style="max-width: 100%"
    >
      <div class="table-wrapper" style="max-width: 100%; overflow-x: auto">
        <h2 class="table-title">{{ title }}</h2>
        <table v-if="data?.results" style="min-width: 100%">
          <thead class="thead" v-if="tableHead && tableHead.length > 0">
            <tr>
              <th v-for="(item, index) in tableHead" :key="index">
                {{ item }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="item in data.results" :key="item.calculationValueLabel">
              <!-- Check if this item has children (main dimension) -->
              <template v-if="item.children && item.children.length > 0">
                <!-- First row: Main dimension with total score -->
                <tr :class="item.calculationValueLabel.toLowerCase()">
                  <td :rowspan="item.children.length">
                    <span
                      v-if="item.calculationValueLabel !== 'OTHER'"
                      data-label="Main dimension"
                      >{{ item.calculationValueLabel }}</span
                    >
                  </td>
                  <td :rowspan="item.children.length">
                    <span v-if="item.calculationValueLabel !== 'OTHER'" data-label="Total score">{{
                      item.calculationResultValue.toFixed(decimalAmount)
                    }}</span>
                  </td>
                  <td>
                    <span data-label="Subdimension">{{
                      item.children[0].calculationValueLabel
                    }}</span>
                  </td>
                  <td>
                    <span data-label="Average score">{{
                      item.children[0].calculationResultValue.toFixed(decimalAmount)
                    }}</span>
                  </td>
                  <td>
                    <span data-label="Standard deviation">{{
                      item.children[0].standardDeviation?.toFixed(decimalAmount) || ''
                    }}</span>
                  </td>
                  <td>
                    <span data-label="DINAMO norm score">{{
                      item.children[0].calculationNorm?.toFixed(decimalAmount) || ''
                    }}</span>
                  </td>
                </tr>

                <!-- Subsequent rows: Only sub-dimensions -->
                <tr
                  v-for="child in item.children.slice(1)"
                  :key="child.calculationValueLabel"
                  :class="item.calculationValueLabel.toLowerCase()"
                >
                  <td>
                    <span data-label="Subdimension">{{ child.calculationValueLabel }}</span>
                  </td>
                  <td>
                    <span data-label="Average score">{{
                      child.calculationResultValue.toFixed(decimalAmount)
                    }}</span>
                  </td>
                  <td>
                    <span data-label="Standard deviation">{{
                      child.standardDeviation?.toFixed(decimalAmount) || ''
                    }}</span>
                  </td>
                  <td>
                    <span data-label="DINAMO norm score">{{
                      child.calculationNorm?.toFixed(decimalAmount) || ''
                    }}</span>
                  </td>
                </tr>
              </template>

              <!-- Standalone rows (no children) -->
              <tr v-else class="only-top">
                <td>
                  <span data-label="Subdimension">{{ item.calculationValueLabel }}</span>
                </td>
                <td>
                  <span data-label="Average score">{{
                    item.calculationResultValue.toFixed(decimalAmount)
                  }}</span>
                </td>
                <td>
                  <span data-label="Standard deviation">{{
                    item.standardDeviation?.toFixed(decimalAmount) || ''
                  }}</span>
                </td>
                <td>
                  <span data-label="DINAMO norm score">{{
                    item.calculationNorm?.toFixed(decimalAmount) || ''
                  }}</span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="isLoading" class="loading-overlay">Loading chart...</div>
  </div>
</template>

<script>
import {
  defineComponent,
  computed,
  ref,
  watchEffect,
  watch,
  nextTick,
  onMounted,
  onUnmounted
} from 'vue'

import { useAuthenticationData } from '@/composables/useAuthenticationData'
import { useGlobalStore } from '@/stores/global'
import { useCurrentUserData } from '@/composables/useUserData'
import { useECharts } from '@/composables/useECharts'

import { resolveEnum } from '@/utils/global'

export default defineComponent({
  components: {},
  props: {
    data: {
      type: Object
    },
    type: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    tableHead: {
      type: Array,
      required: false
    },
    rotate: {
      type: Number,
      required: false
    },
    maxValue: {
      type: Number,
      required: false
    },
    extraClass: {
      type: String,
      required: false
    },
    decimalAmount: {
      type: Number,
      required: false,
      default: 0
    },
    animation: {
      type: Boolean,
      required: false,
      default: true
    },
    showLegend: {
      type: Boolean,
      required: false,
      default: false
    },
    extraTooltipHTML: {
      type: String,
      required: false,
      default: ''
    },
    enableDetailPage: {
      type: Boolean,
      required: false,
      default: false
    },
    multiplyValues: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  setup(props) {
    // Color palettes
    const COLOR_PALETTES = {
      primary: ['#F4D03F', '#5070DD', '#E74C3C', '#B6D634', '#F8F9FA'],
      light: ['#FBF0A3', '#A5B8F5', '#F7C4B8', '#D9F0A3', '#FAFAFA'],
      gauge: ['#5070DD', '#5070DD', '#5070DD', '#5070DD', '#5070DD'],
      gaugePreview: ['#37a2da', '#fd666d', '#67e0e3', '#f39c12', '#2ecc71'],
      ocai: {
        CLAN: '#3498db',
        ADHOCRACY: '#e74c3c',
        MARKET: '#2ecc71',
        HIERARCHY: '#f39c12'
      }
    }

    // Chart type registry with heights
    const CHART_REGISTRY = {
      'ocai-radar': { height: 500 },
      'radar-norm': { height: 600 },
      'big-simple-gauge': { height: 400 },
      'benchmark-bar': { height: 500 },
      'benchmark-bar-with-norm': { height: 500 },
      'benchmark-bar-colored': { height: 500 },
      'resilience-bar': { height: 600 },
      rainfall: { height: 500 },
      pie: { height: 500 }
    }

    // Utility functions
    const prepareSeriesData = (results, valueKey, labelKey = 'calculationValueLabel') => ({
      name: 'Current Values',
      value: results.map((item) => (item[valueKey] || 0).toFixed(props.decimalAmount))
    })

    const prepareNormSeriesData = (results) => ({
      name: 'Norm Values',
      value: results.map((item) => item.calculationNorm || 0)
    })

    const prepareSeriesNames = (results, labelKey = 'calculationValueLabel') => ({
      value: results.map((item) => item[labelKey] || '')
    })

    const createTooltipFormatter =
      (labelKey = 'calculationValueLabel') =>
      (params) => {
        let tooltipContent = '<div style="padding: 8px;">'
        tooltipContent += `${params.seriesName}: ${params.value}`
        tooltipContent += '</div>'
        return tooltipContent
      }

    const getGridConfig = (type) => {
      const isHorizontal = type.includes('horizontal')
      return {
        left: isHorizontal ? 0 : 30,
        right: 30,
        top: 100,
        bottom: 30,
        containLabel: isHorizontal
      }
    }

    const getEmptyChartOptions = (title) => ({
      title: {
        text: title,
        subtext: 'No data available'
      },
      series: []
    })

    const getErrorChartOptions = (title) => ({
      title: {
        text: title,
        subtext: 'Error loading chart'
      },
      series: []
    })

    // Chart type handlers
    const generateGaugeOptions = (data, title) => {
      if (!data.results?.length) return getEmptyChartOptions(title)

      const gaugeData = data.results
        .map((item) => ({
          value: item.calculationResultValue || 0,
          name: item.calculationValueLabel || 'Value'
        }))
        .sort((a, b) => b.value - a.value)

      const maxValue = Math.max(...gaugeData.map((item) => item.value))
      const roundedMax = Math.max(maxValue, props.maxValue || 10)

      const gaugeSeries = gaugeData.map((item, index) => ({
        type: 'gauge',
        name: item.name,
        center: ['50%', '55%'],
        radius: '70%',
        min: 0,
        max: roundedMax,
        splitNumber: 5,
        z: index,
        axisLine: {
          lineStyle: {
            width: 8,
            color: [
              [item.value / roundedMax, COLOR_PALETTES.gauge[index]],
              [1, 'rgba(0,0,0,0.1)']
            ]
          }
        },
        pointer: {
          itemStyle: {
            color: COLOR_PALETTES.gauge[index]
          }
        },
        detail: { show: false },
        data: [{ value: item.value }]
      }))

      return {
        title: { text: title, top: 0 },
        animation: props.animation,
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            const result = data.results?.[params.seriesIndex]
            return result
              ? `${result.calculationValueLabel}: ${result.calculationResultValue.toFixed(
                  props.decimalAmount
                )}`
              : `${params.name}: ${params.value}`
          }
        },
        legend: {
          show: true,
          data: gaugeData.map((item, index) => ({
            name: item.name,
            itemStyle: { color: COLOR_PALETTES.gauge[index] }
          })),
          bottom: 0,
          left: 'center',
          textStyle: { fontSize: 12, color: '#333' },
          itemGap: 30,
          itemWidth: 14,
          itemHeight: 14,
          formatter: function (name) {
            const item = gaugeData.find((d) => d.name === name)
            return `${name}: ${item ? item.value.toFixed(props.decimalAmount) : ''}`
          },
          selectedMode: false
        },
        series: gaugeSeries
      }
    }

    const generateGaugePreviewOptions = (data, title) => {
      if (!data.results?.length) return getEmptyChartOptions(title)

      const gaugePreviewData =
        data.results.length > 0
          ? [
              {
                value: data.results[0].calculationResultValue || 0,
                name: data.results[0].calculationValueLabel || 'Value'
              },
              {
                value: data.results[0].calculationNorm || 0,
                name: 'Norm'
              }
            ]
          : []

      const maxValue = Math.max(...gaugePreviewData.map((item) => item.value))
      const roundedMax = Math.ceil(maxValue)

      const gaugeSeries = gaugePreviewData.map((item, index) => ({
        type: 'gauge',
        name: item.name,
        center: ['50%', '55%'],
        radius: '70%',
        min: 0,
        max: roundedMax,
        splitNumber: 5,
        z: index,
        axisLine: {
          lineStyle: {
            width: 8,
            color: [
              [item.value / roundedMax, COLOR_PALETTES.gaugePreview[index]],
              [1, 'rgba(0,0,0,0.1)']
            ]
          }
        },
        pointer: {
          itemStyle: {
            color: COLOR_PALETTES.gaugePreview[index]
          }
        },
        detail: { show: false },
        data: [{ value: item.value }]
      }))

      return {
        title: { text: title, top: 0 },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            const result = data.results?.[params.seriesIndex]
            return result
              ? `${result.calculationValueLabel}: ${result.calculationResultValue.toFixed(
                  props.decimalAmount
                )}`
              : `${params.name}: ${params.value}`
          }
        },
        legend: {
          show: true,
          data: gaugePreviewData.map((item, index) => ({
            name: item.name,
            itemStyle: { color: COLOR_PALETTES.gaugePreview[index] }
          })),
          bottom: 0,
          left: 'center',
          textStyle: { fontSize: 12, color: '#333' },
          itemGap: 30,
          itemWidth: 14,
          itemHeight: 14,
          formatter: function (name) {
            const item = gaugePreviewData.find((d) => d.name === name)
            return `${name}: ${item ? item.value.toFixed(props.decimalAmount) : ''}`
          },
          selectedMode: false
        },
        series: gaugeSeries
      }
    }

    const generateSimpleGaugeOptions = (data, title) => {
      if (!data.results?.length) return getEmptyChartOptions(title)

      const result = data.results[0]
      const gaugeData = {
        value: result.calculationResultValue || 0,
        name: result.calculationValueLabel || 'Value',
        targetValue: result.calculationNorm || 20
      }

      const gaugeColor = '#151cce'
      const targetColor = '#26DBB9'
      const roundedMaxDefault = Math.max(gaugeData.value, 100)

      const roundedMax = props.maxValue || roundedMaxDefault

      const gaugeSeries = [
        {
          type: 'gauge',
          name: gaugeData.name,
          center: ['50%', '55%'],
          radius: '90%',
          min: 0,
          max: roundedMax,
          splitNumber: 5,
          progress: { show: true },
          axisLine: {
            lineStyle: {
              width: 8,
              color: [
                [gaugeData.value / roundedMax, gaugeColor],
                [1, 'rgba(0,0,0,0.1)']
              ]
            }
          },
          pointer: {
            itemStyle: { color: gaugeColor }
          },
          detail: {
            show: true,
            valueAnimation: false,
            formatter: function (params) {
              //return params.toFixed(props.decimalAmount)
              return `${params.toFixed(props.decimalAmount)}${props.extraTooltipHTML || ''}`
            },
            fontSize: 16,
            fontWeight: 'bold',
            color: gaugeColor,
            offsetCenter: [0, '80%']
          },
          title: {
            show: true,
            offsetCenter: [0, '100%'],
            fontSize: 14,
            color: '#333',
            fontWeight: 'normal'
          },
          data: [
            {
              value: props.multiplyValues ? gaugeData.value * 100 : gaugeData.value,
              name: gaugeData.name
            }
          ]
        },
        {
          type: 'gauge',
          name: `${gaugeData.name} Target`,
          center: ['50%', '55%'],
          radius: '80%',
          min: 0,
          max: roundedMax,
          splitNumber: 1,
          axisLine: {
            lineStyle: {
              width: 4,
              color: [
                [gaugeData.targetValue / roundedMax, targetColor],
                [1, 'transparent']
              ]
            }
          },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: { show: false },
          pointer: { show: false },
          detail: { show: false },
          title: { show: false },
          data: [
            {
              value: gaugeData.targetValue,
              name: `${gaugeData.name} Target`
            }
          ]
        }
      ]

      return {
        title: { text: title || gaugeData.name, top: 0 },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return `${params.name}: ${params.value.toFixed(props.decimalAmount)}`
          }
        },
        series: gaugeSeries
      }
    }

    const generateBigSimpleGaugeOptions = (data, title) => {
      if (!data.results?.length) return getEmptyChartOptions(title)

      const result = data.results[0]
      const gaugeData = {
        value: result.calculationResultValue.toFixed(props.decimalAmount) || 0,
        name: result.calculationValueLabel || 'Value',
        targetValue: result.calculationNorm || 20
      }

      const gaugeColor = '#151cce'
      const targetColor = '#26DBB9'
      const roundedMaxDefault = Math.max(gaugeData.value, 100)

      const roundedMax = props.maxValue || roundedMaxDefault

      const gaugeSeries = [
        {
          type: 'gauge',
          name: gaugeData.name,
          center: ['50%', '55%'],
          radius: '80%',
          min: 0,
          max: roundedMax,
          splitNumber: 5,
          progress: { show: true },
          pointer: {
            itemStyle: { color: gaugeColor }
          },
          detail: {
            show: true,
            valueAnimation: true,
            formatter: '{value}',
            fontSize: 16,
            fontWeight: 'bold',
            color: gaugeColor,
            offsetCenter: [0, '80%'],
            formatter: function (params) {
              return `${params}${props.extraTooltipHTML || ''}`
            }
          },
          title: {
            show: true,
            offsetCenter: [0, '100%'],
            fontSize: 14,
            color: '#333',
            fontWeight: 'normal'
          },
          data: [
            {
              value: props.multiplyValues ? gaugeData.value * 100 : gaugeData.value,
              name: gaugeData.name
            }
          ]
        },
        {
          type: 'gauge',
          name: `${gaugeData.name} Target`,
          center: ['50%', '55%'],
          radius: '80%',
          min: 0,
          max: roundedMax,
          splitNumber: 1,
          axisLine: {
            lineStyle: {
              width: 4,
              color: [
                [gaugeData.targetValue / roundedMax, targetColor],
                [1, 'transparent']
              ]
            }
          },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: { show: false },
          pointer: { show: false },
          detail: { show: false },
          title: { show: false },
          data: [
            {
              value: gaugeData.targetValue,
              name: `${gaugeData.name} Target`
            }
          ]
        }
      ]

      return {
        title: { text: title || gaugeData.name, top: 0 },
        series: gaugeSeries
      }
    }

    const generateRadarOptions = (data, title) => {
      if (!data.results?.length) return getEmptyChartOptions(title)

      const maxValue = Math.max(...data.results.map((r) => r.calculationResultValue))
      const roundedMax = Math.ceil(maxValue)

      const indicators = data.results.map((item) => ({
        name: item.calculationValueLabel,
        min: 0,
        max: roundedMax
      }))

      const seriesData = data.results.map((item) => {
        const values = data.results.map((result) =>
          result.calculationValueLabel === item.calculationValueLabel
            ? result.calculationResultValue
            : 0
        )

        return {
          name: item.calculationValueLabel,
          value: values,
          itemStyle: {
            color: COLOR_PALETTES.ocai[item.calculationValueLabel] || '#95a5a6'
          }
        }
      })

      return {
        title: { text: title },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            const dataIndex = params.dataIndex
            const result = data.results?.[dataIndex]
            return result
              ? `${result.calculationValueLabel}: ${result.calculationResultValue.toFixed(
                  props.decimalAmount
                )}`
              : `${params.name}: ${params.value}`
          }
        },
        legend: {
          data: data.results.map((item) => item.calculationValueLabel),
          bottom: 10,
          left: 'center',
          textStyle: { fontSize: 12 },
          itemGap: 20,
          itemWidth: 10,
          itemHeight: 10,
          selectedMode: false,
          formatter: function (name) {
            const item = data.results?.find((d) => d.calculationValueLabel === name)
            return `${name}: ${
              item ? item.calculationResultValue.toFixed(props.decimalAmount) : ''
            }`
          }
        },
        radar: {
          indicator: indicators,
          radius: '66.66%',
          splitNumber: roundedMax,
          axisLabel: {
            show: true,
            fontSize: 10,
            color: '#666',
            formatter: function (value) {
              return value.toFixed(props.decimalAmount)
            },
            showMinLabel: false,
            showMaxLabel: true
          },
          splitLine: {
            show: true,
            lineStyle: { color: '#ddd', width: 1 }
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: ['rgba(250,250,250,0.1)', 'rgba(250,250,250,1)']
            }
          }
        },
        series: [
          {
            type: 'radar',
            data: seriesData,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { width: 2 },
            areaStyle: { opacity: 0.1 }
          }
        ]
      }
    }

    const generateOcaiRadarOptions = (data, title) => {
      if (!data.results?.length) return getEmptyChartOptions(title)

      const sortedResults = [...data.results].sort((a, b) => a.sortOrder - b.sortOrder)

      // Move this calculation up before using roundedMax
      const maxValue = Math.max(...sortedResults.map((r) => r.calculationResultValue))
      const roundedMaxDefault = Math.ceil(maxValue / 20) * 20

      const roundedMax = props.maxValue || roundedMaxDefault

      const indicators = sortedResults
        .map((item) => ({
          name: item.calculationValueLabel,
          min: 0,
          max: roundedMax,
          alignTicks: false
        }))
        .reverse() // Add .reverse() here

      // Custom indicators for the rotated radar with specific labels
      // Order: right (0°), bottom (90°), left (180°), top (270°)
      const rotatedRadarIndicators = [
        'Flexibility and freedom',
        'Internal\nfocus\nand\nintegration',
        'Stability and control',
        'External\nfocus\nand\ndifferentation'
      ].map((label, index) => ({
        name: label,
        min: 0,
        max: roundedMax,
        alignTicks: false
      }))

      const normalSeriesData = {
        name: 'Current Values',
        value: sortedResults
          .map((item) => (item.calculationResultValue || 0).toFixed(props.decimalAmount))
          .reverse() // Also reverse the data values to match
      }

      // Create zero-value data for the overlay radar
      const zeroSeriesData = {
        name: 'Overlay Axis',
        value: rotatedRadarIndicators.map(() => 0)
      }

      return {
        title: { text: title },
        _refreshKey: Date.now(),
        tooltip: {
          trigger: 'item',
          confine: true,
          formatter: function (params) {
            let tooltipContent = '<div style="padding: 8px;">'
            if (params.seriesName === 'Current Values') {
              tooltipContent += '<strong>Current Values</strong><br/>'
              data.results?.forEach((result) => {
                tooltipContent += `
                <div style="margin-bottom: 2px;">
                  ${result.calculationValueLabel}: ${result.calculationResultValue.toFixed(
                    props.decimalAmount
                  )}
                </div>
              `
              })
            }
            tooltipContent += '</div>'
            return tooltipContent
          }
        },
        legend: {
          show: props.showLegend,
          selectedMode: false
        },
        radar: [
          {
            startAngle: props.rotate || 0,
            indicator: indicators,
            radius: window.innerWidth < 768 ? '50%' : '66.66%',
            splitNumber: 5,
            shape: 'polygon',
            axisTick: {
              show: false,
              alignWithLabel: false
            },
            axisLabel: {
              show: true,
              fontSize: 10,
              color: '#666',
              formatter: function (value) {
                return value.toFixed(props.decimalAmount)
              },
              showMinLabel: false,
              showMaxLabel: true
            },
            axisName: {
              show: true,
              fontSize: window.innerWidth < 768 ? 8 : 12,
              color: '#333',
              formatter: function (name) {
                return name
              },
              rich: {
                rotated: {
                  transform: 'rotate(45deg)',
                  display: 'inline-block'
                }
              }
            },
            axisNameGap: window.innerWidth < 768 ? 10 : 15,
            nameLocation: 'end',
            splitLine: {
              show: true,
              lineStyle: { color: '#ddd', width: 1 }
            },
            splitArea: {
              show: true,
              areaStyle: {
                color: ['rgba(250,250,250,0.1)', 'rgba(250,250,250,1)']
              }
            }
          },
          {
            startAngle: (props.rotate || 0) + 180,
            indicator: indicators,
            radius: window.innerWidth < 768 ? '50%' : '66.66%',
            splitNumber: 5,
            shape: 'polygon',
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            axisName: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: { color: '#ddd', width: 1, type: 'solid' }
            },
            splitArea: {
              show: false
            }
          },
          {
            startAngle: 90,
            indicator: rotatedRadarIndicators,
            radius: window.innerWidth < 768 ? '50%' : '66.66%',
            splitNumber: 5,
            shape: 'polygon',
            axisTick: {
              show: false,
              alignWithLabel: false
            },
            axisLabel: {
              show: false
            },
            axisName: {
              show: true,
              fontSize: window.innerWidth < 768 ? 8 : 12,
              color: '#333',
              formatter: function (name) {
                return name
              }
            },
            axisNameGap: window.innerWidth < 768 ? 10 : 15,
            nameLocation: 'end',
            splitLine: {
              show: false
            },
            splitArea: {
              show: false
            }
          }
        ],
        series: [
          {
            type: 'radar',
            name: 'Current Values',
            radarIndex: 0,
            data: [normalSeriesData],
            symbol: 'circle',
            symbolSize: 6,
            z: 1,
            lineStyle: { width: 2, color: '#5070DD' },
            areaStyle: { opacity: 0.1, color: '#5070DD' },
            itemStyle: { color: '#5070DD' }
          },
          {
            type: 'radar',
            name: 'Overlay Radar',
            radarIndex: 1,
            data: [normalSeriesData],
            symbol: 'none',
            symbolSize: 0,
            z: 2,
            lineStyle: { width: 0, color: 'transparent' },
            areaStyle: { opacity: 0, color: 'transparent' },
            itemStyle: { color: 'transparent' },
            silent: true
          },
        //   {
        //     type: 'radar',
        //     name: 'Rotated Overlay Radar',
        //     radarIndex: 2,
        //     data: [zeroSeriesData],
        //     symbol: 'none',
        //     symbolSize: 0,
        //     z: 3,
        //     lineStyle: { width: 0, color: 'transparent' },
        //     areaStyle: { opacity: 0, color: 'transparent' },
        //     itemStyle: { color: 'transparent' },
        //     silent: true
        //   }
        ]
      }
    }

    // const generateOcaiRadarOptions = (data, title) => {
    //   if (!data.results?.length) return getEmptyChartOptions(title)

    //   const sortedResults = [...data.results].sort((a, b) => a.sortOrder - b.sortOrder)

    //   // Move this calculation up before using roundedMax
    //   const maxValue = Math.max(...sortedResults.map((r) => r.calculationResultValue))
    //   const roundedMaxDefault = Math.ceil(maxValue / 20) * 20
    //   const roundedMax = props.maxValue || roundedMaxDefault

    //   const indicators = sortedResults
    //     .map((item) => ({
    //       name: item.calculationValueLabel,
    //       min: 0,
    //       max: roundedMax,
    //       alignTicks: false
    //     }))
    //     .reverse()

    //   const normalSeriesData = {
    //     name: 'Current Values',
    //     value: sortedResults
    //       .map((item) =>
    //         parseFloat((item.calculationResultValue || 0).toFixed(props.decimalAmount))
    //       )
    //       .reverse()
    //   }

    //   // Calculate positions for overlay labels with rotated axis
    //   const calculateLabelPositions = () => {
    //     const centerX = 50 // Center of chart in percentage
    //     const centerY = 50 // Center of chart in percentage
    //     const radius = 35 // Distance from center for labels
    //     const angleStep = (2 * Math.PI) / sortedResults.length
    //     const startAngle = ((props.rotate || 0) * Math.PI) / 180

    //     // Add the axis rotation offset (-135 degrees)
    //     const axisRotation = (-135 * Math.PI) / 180

    //     return sortedResults.map((item, index) => {
    //       // Calculate the original angle
    //       const originalAngle = startAngle + index * angleStep

    //       // Apply the axis rotation to the angle
    //       const rotatedAngle = originalAngle + axisRotation

    //       // Calculate new positions based on rotated angle
    //       const x = centerX + radius * Math.cos(rotatedAngle)
    //       const y = centerY + radius * Math.sin(rotatedAngle)

    //       return {
    //         x: x + '%',
    //         y: y + '%',
    //         angle: rotatedAngle,
    //         label: item.calculationValueLabel
    //       }
    //     })
    //   }

    //   const labelPositions = calculateLabelPositions()

    //   // Helper function to create rotated cross pattern
    //   const createRotatedCross = () => {
    //     const centerX = 50
    //     const centerY = 50
    //     const crossLength = 60
    //     const lineWidth = 2
    //     const color = '#ddd'
    //     const rotation = (0 * Math.PI) / 180

    //     // Calculate rotated endpoints
    //     const halfLength = crossLength / 2

    //     // First diagonal (top-left to bottom-right)
    //     const x1 = centerX + halfLength * Math.cos(rotation)
    //     const y1 = centerY + halfLength * Math.sin(rotation)
    //     const x2 = centerX + halfLength * Math.cos(rotation + Math.PI)
    //     const y2 = centerY + halfLength * Math.sin(rotation + Math.PI)

    //     // Second diagonal (top-right to bottom-left)
    //     const x3 = centerX + halfLength * Math.cos(rotation + Math.PI / 2)
    //     const y3 = centerY + halfLength * Math.sin(rotation + Math.PI / 2)
    //     const x4 = centerX + halfLength * Math.cos(rotation + (3 * Math.PI) / 2)
    //     const y4 = centerY + halfLength * Math.sin(rotation + (3 * Math.PI) / 2)

    //     return [
    //       // First diagonal
    //       {
    //         type: 'line',
    //         shape: {
    //           x1: x1,
    //           y1: y1,
    //           x2: x2,
    //           y2: y2
    //         },
    //         style: {
    //           stroke: color,
    //           lineWidth: lineWidth,
    //           opacity: 0.7
    //         },
    //         z: 50
    //       },
    //       // Second diagonal
    //       {
    //         type: 'line',
    //         shape: {
    //           x1: x3,
    //           y1: y3,
    //           x2: x4,
    //           y2: y4
    //         },
    //         style: {
    //           stroke: color,
    //           lineWidth: lineWidth,
    //           opacity: 0.7
    //         },
    //         z: 50
    //       }
    //     ]
    //   }

    //   return {
    //     title: { text: title },
    //     _refreshKey: Date.now(),
    //     tooltip: {
    //       trigger: 'item',
    //       confine: true,
    //       formatter: function (params) {
    //         let tooltipContent = '<div style="padding: 8px;">'
    //         if (params.seriesName === 'Current Values') {
    //           tooltipContent += '<strong>Current Values</strong><br/>'
    //           data.results?.forEach((result) => {
    //             tooltipContent += `
    //       <div style="margin-bottom: 2px;">
    //         ${result.calculationValueLabel}: ${result.calculationResultValue.toFixed(
    //           props.decimalAmount
    //         )}
    //       </div>
    //     `
    //           })
    //         }
    //         tooltipContent += '</div>'
    //         return tooltipContent
    //       }
    //     },
    //     legend: {
    //       show: props.showLegend,
    //       selectedMode: false
    //     },
    //     // Add graphic elements for overlay labels
    //     graphic: [
    //       // Add category labels on top
    //       ...createRotatedCross(), // or createFullCross() or createRotatedCross()
    //       // Then add your labels and other elements
    //       ...labelPositions.map((pos, index) => ({
    //         type: 'text',
    //         left: pos.x,
    //         top: pos.y,
    //         style: {
    //           text: pos.label,
    //           fontSize: window.innerWidth < 768 ? 10 : 12,
    //           fontWeight: 'bold',
    //           fill: '#2c3e50',
    //           textAlign: 'center',
    //           textVerticalAlign: 'middle'
    //         },
    //         z: 100
    //       }))
    //     ],
    //     radar: {
    //       startAngle: props.rotate || 0,
    //       indicator: indicators,
    //       radius: window.innerWidth < 768 ? '50%' : '66.66%',
    //       splitNumber: 4,
    //       axisTick: {
    //         show: true,
    //         alignWithLabel: false
    //       },
    //       axisLabel: {
    //         show: true,
    //         fontSize: 10,
    //         color: '#666',
    //         formatter: function (value) {
    //           return value.toFixed(props.decimalAmount)
    //         },
    //         showMinLabel: false,
    //         showMaxLabel: true
    //       },
    //       axisName: {
    //         show: true,
    //         fontSize: window.innerWidth < 768 ? 8 : 12,
    //         color: '#333',
    //         formatter: function (name) {
    //           return name
    //         },
    //         rich: {
    //           rotated: {
    //             transform: 'rotate(45deg)',
    //             display: 'inline-block'
    //           }
    //         }
    //       },
    //       axisNameGap: window.innerWidth < 768 ? 10 : 15,
    //       nameLocation: 'end',
    //       splitLine: {
    //         show: true,
    //         lineStyle: { color: '#ddd', width: 1 }
    //       },
    //       splitArea: {
    //         show: true,
    //         areaStyle: {
    //           color: ['rgba(250,250,250,0.1)', 'rgba(250,250,250,1)']
    //         }
    //       }
    //     },
    //     series: [
    //       {
    //         type: 'radar',
    //         name: 'Current Values',
    //         data: [normalSeriesData],
    //         symbol: 'circle',
    //         symbolSize: 6,
    //         z: 1,
    //         lineStyle: { width: 2, color: '#5070DD' },
    //         areaStyle: { opacity: 0.1, color: '#5070DD' },
    //         itemStyle: { color: '#5070DD' }
    //       }
    //     ]
    //   }
    // }

    const generateRadarNormOptions = (data, title) => {
      if (!data.results?.length) return getEmptyChartOptions(title)

      const maxValue = Math.max(...data.results.map((r) => r.calculationResultValue))
      const roundedMaxDefault = Math.ceil(maxValue / 20) * 20

      const roundedMax = props.maxValue || roundedMaxDefault

      const indicators = data.results.map((item) => ({
        name: item.calculationValueLabel,
        min: 0,
        max: roundedMax,
        alignTicks: false
      }))

      const normalSeriesData = {
        name: 'Current Values',
        value: data.results.map((item) => item.calculationResultValue)
      }

      const normSeriesData = {
        name: 'Norm Values',
        value: data.results.map((item) => item.calculationNorm)
      }

      return {
        title: { text: title },
        tooltip: {
          trigger: 'item',
          confine: true,
          formatter: function (params) {
            let tooltipContent = '<div style="padding: 8px;">'
            if (params.seriesName === 'Current Values') {
              tooltipContent += '<strong>Current Values</strong><br/>'
              data.results?.forEach((result) => {
                tooltipContent += `
                <div style="margin-bottom: 2px;">
                  ${result.calculationValueLabel}: ${result.calculationResultValue.toFixed(
                    props.decimalAmount
                  )}
                </div>
              `
              })
            }

            if (params.seriesName === 'Norm Values') {
              tooltipContent += '<strong>Norm Values</strong><br/>'
              data.results?.forEach((result) => {
                tooltipContent += `
                <div style="margin-bottom: 2px;">
                  ${result.calculationValueLabel}: ${result.calculationNorm.toFixed(
                    props.decimalAmount
                  )}
                </div>
              `
              })
            }

            tooltipContent += '</div>'
            return tooltipContent
          }
        },
        legend: {
          show: true,
          selectedMode: false
        },
        radar: {
          startAngle: 45,
          indicator: indicators,
          radius: window.innerWidth < 768 ? '50%' : '66.66%',
          splitNumber: 4,
          axisTick: {
            show: true,
            alignWithLabel: false
          },
          axisLabel: {
            show: true,
            fontSize: 10,
            color: '#666',
            formatter: function (value) {
              return value.toFixed(props.decimalAmount)
            },
            showMinLabel: false,
            showMaxLabel: true
          },
          axisName: {
            show: true,
            fontSize: window.innerWidth < 768 ? 8 : 12,
            color: '#333',
            formatter: function (name) {
              return name
            }
          },
          axisNameGap: window.innerWidth < 768 ? 10 : 15,
          nameLocation: 'end',
          splitLine: {
            show: true,
            lineStyle: { color: '#ddd', width: 1 }
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: ['rgba(250,250,250,0.1)', 'rgba(250,250,250,1)']
            }
          }
        },
        series: [
          {
            type: 'radar',
            name: 'Current Values',
            data: [normalSeriesData],
            symbol: 'circle',
            symbolSize: 6,
            z: 1,
            lineStyle: { width: 2, color: '#5070DD' },
            areaStyle: { opacity: 0.1, color: '#5070DD' },
            itemStyle: { color: '#5070DD' }
          },
          {
            type: 'radar',
            name: 'Norm Values',
            data: [normSeriesData],
            symbol: 'circle',
            symbolSize: 6,
            z: 2,
            lineStyle: { width: 2, color: '#e74c3c' },
            areaStyle: { opacity: 0.1, color: '#e74c3c' },
            itemStyle: { color: '#e74c3c' }
          }
        ]
      }
    }

    const generateBenchmarkBarOptions = (data, title) => {
      if (!data.results?.length) return getEmptyChartOptions(title)

      const valueSeriesData = prepareSeriesData(data.results, 'calculationResultValue')
      const seriesNames = prepareSeriesNames(data.results)

      return {
        title: { text: title, subtext: '' },
        animation: true,
        grid: getGridConfig('benchmark-bar'),
        tooltip: {
          trigger: 'item',
          formatter: createTooltipFormatter()
        },
        legend: {
          data: ['Score', 'Benchmark'],
          selectedMode: false,
          show: false
        },
        toolbox: { show: false },
        calculable: true,
        xAxis: {
          type: 'category',
          data: seriesNames.value,
          axisLabel: { interval: 0 }
        },
        yAxis: { type: 'value' },
        series: [
          {
            name: 'Score',
            type: 'bar',
            data: valueSeriesData.value,
            xAxisIndex: 0,
            yAxisIndex: 0,
            label: {
              show: true,
              position: 'inside',
              valueAnimation: false
            }
          }
        ]
      }
    }

    const generateBenchmarkBarColoredOptions = (data, title) => {
      if (!data.results?.length) return getEmptyChartOptions(title)

      const valueSeriesData = prepareSeriesData(data.results, 'calculationResultValue')
      const normSeriesData = prepareNormSeriesData(data.results)
      const seriesNames = prepareSeriesNames(data.results)

      return {
        title: { text: title, subtext: '' },
        animation: true,
        grid: getGridConfig('benchmark-bar-colored'),
        tooltip: {
          trigger: 'item',
          formatter: createTooltipFormatter()
        },
        legend: {
          data: ['Score', 'Benchmark'],
          selectedMode: false,
          show: props.showLegend
        },
        toolbox: { show: false },
        calculable: true,
        xAxis: {
          type: 'category',
          data: seriesNames.value,
          axisLabel: { interval: 0 }
        },
        yAxis: { type: 'value', max: props.maxValue },
        series: [
          {
            name: 'Score',
            type: 'bar',
            data: valueSeriesData.value,
            xAxisIndex: 0,
            yAxisIndex: 0,
            label: {
              show: true,
              position: 'insideBottom',
              valueAnimation: false
            },
            itemStyle: {
              color: function (params) {
                return COLOR_PALETTES.primary[params.dataIndex]
              },
              borderColor: 'black',
              borderWidth: 1
            }
          },
          {
            name: 'Benchmark',
            type: 'bar',
            data: normSeriesData.value,
            xAxisIndex: 0,
            yAxisIndex: 0,
            label: {
              show: true,
              position: 'insideBottom',
              valueAnimation: false
            },
            itemStyle: {
              color: function (params) {
                return COLOR_PALETTES.light[params.dataIndex]
              },
              borderColor: 'black',
              borderWidth: 1
            }
          }
        ]
      }
    }

    const generateBenchmarkBarWithNormOptions = (data, title) => {
      if (!data.results?.length) return getEmptyChartOptions(title)

      const valueSeriesData = prepareSeriesData(data.results, 'calculationResultValue')
      const normSeriesData = prepareNormSeriesData(data.results)
      const seriesNames = prepareSeriesNames(data.results)

      return {
        title: { text: title, subtext: '' },
        animation: true,
        grid: {
          ...getGridConfig('benchmark-bar-with-norm'),
          bottom: props.showLegend ? 100 : 0
        },
        tooltip: {
          trigger: 'item',
          formatter: createTooltipFormatter()
        },
        legend: {
          data: ['Score', 'Benchmark'],
          selectedMode: false,
          show: props.showLegend
        },
        toolbox: { show: false },
        calculable: true,
        xAxis: {
          type: 'category',
          data: seriesNames.value,
          axisLabel: { interval: 0 }
        },
        yAxis: { type: 'value' },
        series: [
          {
            name: 'Score',
            type: 'bar',
            data: valueSeriesData.value,
            xAxisIndex: 0,
            yAxisIndex: 0,
            label: {
              show: true,
              position: 'insideBottom',
              valueAnimation: false
            }
          },
          {
            name: 'Benchmark',
            type: 'bar',
            data: normSeriesData.value,
            xAxisIndex: 0,
            yAxisIndex: 0,
            label: {
              show: true,
              position: 'insideBottom',
              valueAnimation: false
            }
          }
        ]
      }
    }

    // OG
    const generateResilienceBarOptions = (data, title) => {
      if (!data.results?.length) return getEmptyChartOptions(title)

      //   const valueSeriesData = {
      //     name: 'Current Values',
      //     value: data.results.map(
      //       (item) => parseFloat((item.calculationResultValue || 0).toFixed(props.decimalAmount)) * 100
      //     )
      //   }

      const valueSeriesData = {
        name: 'Current Values',
        value: data.results.map((item) => Math.round((item.calculationResultValue || 0) * 100))
      }

      const seriesNames = prepareSeriesNames(data.results)

      return {
        title: { text: title, subtext: '' },
        grid: getGridConfig('resilience-bar'),
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            let tooltipContent = '<div style="padding: 8px;">'
            tooltipContent += `${params.seriesName}: ${params.value}%`
            tooltipContent += '</div>'
            return tooltipContent
          }
        },
        legend: {
          data: ['Score'],
          selectedMode: false,
          show: props.showLegend
        },
        toolbox: { show: false },
        calculable: true,
        xAxis: {
          type: 'category',
          data: seriesNames.value,
          axisLabel: {
            interval: 0,
            fontSize: 10,
            rotate: -45
          }
        },
        yAxis: {
          type: 'value',
          max: props.maxValue || 100
        },
        series: [
          {
            name: 'Score',
            type: 'bar',
            data: valueSeriesData.value,
            xAxisIndex: 0,
            yAxisIndex: 0,

            // itemStyle: {
            //   color: function (params) {
            //     return COLOR_PALETTES.primary[params.dataIndex]
            //   }
            // }
            label: {
              show: true,
              position: 'insideBottom',
              valueAnimation: false,
              formatter: '{c}%' // {c} represents the data value
            }
          }
        ]
      }
    }

    const generateBenchmarkBarHorizontalOptions = (data, title) => {
      if (!data.results?.length) return getEmptyChartOptions(title)

      // Reverse the results array to get Z-A order
      const reversedResults = [...data.results].reverse()

      const valueSeriesData = {
        name: 'Current Values',
        value: reversedResults.map((item) =>
          (item.calculationResultValue || 0).toFixed(props.decimalAmount)
        )
      }

      const seriesNames = prepareSeriesNames(reversedResults)

      return {
        width: '98%',
        title: { text: title, subtext: '' },
        grid: getGridConfig('benchmark-bar-horizontal'),
        tooltip: {
          trigger: 'item',
          formatter: createTooltipFormatter()
          //   formatter: function (params) {
          //     console.log('params:', params)
          //     console.log('params.value:', params.value)
          //     console.log('params.value.toFixed(2):', params.value.toFixed(2))
          //     console.log('props.decimalAmount:', props.decimalAmount)
          //     return `${params.value.toFixed(props.decimalAmount)}${props.extraTooltipHTML || ''}`
          //   }
        },
        legend: {
          data: ['Score'],
          selectedMode: false,
          show: false
        },
        toolbox: { show: false },
        calculable: true,
        yAxis: {
          type: 'category',
          data: seriesNames.value,
          axisLabel: {
            interval: 0,
            fontSize: 10
          }
        },
        xAxis: {
          type: 'value',
          max: props.maxValue || 10.0
        },
        series: [
          {
            name: 'Score',
            type: 'bar',
            data: valueSeriesData.value,
            xAxisIndex: 0,
            yAxisIndex: 0,
            label: {
              show: true,
              position: 'insideLeft',
              valueAnimation: false
            }
          }
        ]
      }
    }

    const generateBenchmarkBarHorizontalWithNormOptions = (data, title) => {
      if (!data.results?.length) return getEmptyChartOptions(title)

      const valueSeriesData = {
        name: 'Current Values',
        value: data.results.map((item) =>
          (item.calculationResultValue || 0).toFixed(props.decimalAmount)
        )
      }
      const normSeriesData = prepareNormSeriesData(data.results)
      const seriesNames = prepareSeriesNames(data.results)

      return {
        width: '98%',
        title: { text: title, subtext: '' },
        grid: getGridConfig('benchmark-bar-horizontal-with-norm'),
        tooltip: {
          trigger: 'item',
          formatter: createTooltipFormatter()
        },
        legend: {
          data: ['Score'],
          selectedMode: false,
          show: false
        },
        toolbox: { show: false },
        calculable: true,
        yAxis: {
          type: 'category',
          data: seriesNames.value,
          axisLabel: {
            interval: 0,
            fontSize: 10
          }
        },
        xAxis: {
          type: 'value',
          max: data.maxScore || 10.0
        },
        series: [
          {
            name: 'Score',
            type: 'bar',
            data: valueSeriesData.value,
            xAxisIndex: 0,
            yAxisIndex: 0
          },
          {
            name: 'Benchmark',
            type: 'bar',
            data: normSeriesData.value,
            xAxisIndex: 0,
            yAxisIndex: 0
          }
        ]
      }
    }

    const generatePieOptions = (data, title) => {
      if (!data.results?.length) return getEmptyChartOptions(title)

      // Sort by sortOrder like your other charts
      const sortedResults = [...data.results].sort((a, b) => a.sortOrder - b.sortOrder)

      return {
        title: {
          text: title,
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            data: sortedResults.map((item) => ({
              value: (item.calculationResultValue || 0).toFixed(props.decimalAmount),
              name: item.calculationValueLabel || 'Unknown'
            })),
            label: {
              show: true,
              position: 'inside',
              formatter: (params) => {
                return parseInt(params.value).toFixed(props.decimalAmount) + '%'
              },
              fontSize: 12,
              fontWeight: 'bold'
            }
            // emphasis: {
            //   itemStyle: {
            //     shadowBlur: 5,
            //     shadowOffsetX: 0,
            //     shadowColor: 'rgba(0, 0, 0, 0.25)'
            //   }
            // }
          }
        ]
      }
    }

    // Chart type handlers registry
    const chartHandlers = {
      gauge: generateGaugeOptions,
      'gauge-preview': generateGaugePreviewOptions,
      'simple-gauge': generateSimpleGaugeOptions,
      'big-simple-gauge': generateBigSimpleGaugeOptions,
      radar: generateRadarOptions,
      'radar-norm': generateRadarNormOptions,
      'ocai-radar': generateOcaiRadarOptions,
      'benchmark-bar': generateBenchmarkBarOptions,
      'benchmark-bar-colored': generateBenchmarkBarColoredOptions,
      'benchmark-bar-with-norm': generateBenchmarkBarWithNormOptions,
      'resilience-bar': generateResilienceBarOptions,
      'benchmark-bar-horizontal': generateBenchmarkBarHorizontalOptions,
      'benchmark-bar-horizontal-with-norm': generateBenchmarkBarHorizontalWithNormOptions,
      pie: generatePieOptions
    }

    const isAuthenticated = computed(() => {
      return useAuthenticationData().data.value.isAuthenticated
    })

    const globalStore = useGlobalStore()
    const { getCurrentUser } = useCurrentUserData()
    const { chartRef, isLoading, initChart, updateChart, chartInstance, resizeChart } = useECharts()

    // Memoized chart height calculation
    const chartHeight = computed(() => {
      if (props.type === 'simple-gauge') {
        const result = props.data?.results?.[0]
        if (!result) return 300

        const baseHeight = 200
        const titleHeight = props.title ? 40 : 0
        const detailHeight = 60
        const padding = 40
        return baseHeight + titleHeight + detailHeight + padding
      }

      const registryConfig = CHART_REGISTRY[props.type]
      if (registryConfig) {
        return window.innerWidth < 600 ? registryConfig.height * 0.8 : registryConfig.height
      }

      return window.innerWidth < 600 ? 300 : 400
    })

    // Memoized chart options generation
    const chartOptions = computed(() => {
      if (!props.data || !props.type) return {}

      // Skip chart generation for table types (they're rendered as HTML)
      if (
        props.type === 'table' ||
        props.type === 'belbin-table' ||
        props.type === 'expanded-table'
      ) {
        return {}
      }

      try {
        const handler = chartHandlers[props.type]
        if (!handler) {
          console.warn(`No handler found for chart type: ${props.type}`)
          return getErrorChartOptions(props.title)
        }

        return handler(props.data, props.title)
      } catch (error) {
        console.error(`Error generating ${props.type} chart:`, error)
        return getErrorChartOptions(props.title)
      }
    })

    // Watch for data changes and update chart
    watchEffect(async () => {
      if (props.data && props.type && Object.keys(chartOptions.value).length > 0) {
        try {
          await initChart(chartOptions.value)
          await nextTick()
        } catch (error) {
          console.error('Error initializing chart:', error)
        }
      }
    })

    // Watch for data changes
    watch(
      () => [props.data, props.type],
      () => {
        if (props.data && props.type && Object.keys(chartOptions.value).length > 0) {
          updateChart(chartOptions.value)
        }
      },
      { deep: true }
    )

    // Initialize chart on mount
    onMounted(() => {
      if (props.data && props.type && Object.keys(chartOptions.value).length > 0) {
        initChart(chartOptions.value)
      }
    })

    // Cleanup on unmount
    onUnmounted(() => {
      if (chartInstance.value) {
        chartInstance.value.dispose()
        chartInstance.value = null
      }
    })

    function returnBelbinTableValueClass(value) {
      if (value > 24) {
        return 'red'
      } else if (value > 19) {
        return 'light-red'
      } else if (value > 14) {
        return 'purple'
      } else if (value > 9) {
        return 'yellow'
      } else {
        return false
      }
    }

    const returnClassBasedOnRules = (item, enableCeiling = false) => {
      //console.log('initial item', item)
      const valueForRuleCheck = enableCeiling
        ? Math.ceil(item.calculationResultValue)
        : item.calculationResultValue.toFixed(props.decimalAmount)

      // First, find if any item in the data has useTopLevelForRules set
      const masterItem = props.data?.results?.find(
        (dataItem) =>
          dataItem.visualizationDetails?.useTopLevelForRules &&
          dataItem.visualizationDetails?.visualizationRule?.length > 0
      )

      const masterItemArrays = props.data?.results
        ?.flat(1)
        ?.find(
          (dataItem) =>
            dataItem?.visualizationDetails?.useTopLevelForRules &&
            dataItem?.visualizationDetails?.visualizationRule?.length > 0
        )

      if (masterItem) {
        // Use the master item's rules for all items
        // console.log('master rule found');
        for (const rule of masterItem.visualizationDetails.visualizationRule) {
          const ruleMin = rule.minValue ? rule.minValue : 0
          const ruleMax = rule.maxValue ? rule.maxValue : 0

          if (
            valueForRuleCheck >= ruleMin &&
            valueForRuleCheck < ruleMax
          ) {
            //console.log(masterItem.visualizationDetails.visualizationRule)

            // Check if the rule has enums
            if (rule.enums && rule.enums.length > 0) {
              // Get the first enum from the rule (assuming one enum per rule)
              const enumValue = rule.enums[0].value
              //console.log('Found matching rule with enum value:', enumValue + ' - ' + getEnumVal(enumValue))
              return getEnumVal(enumValue).toLowerCase()
            }
          }
        }
      } else if (masterItemArrays) {
        // Use the master item's rules for all items
        // console.log('master rule found');
        for (const rule of masterItemArrays.visualizationDetails.visualizationRule) {
          const ruleMin = rule.minValue ? rule.minValue : 0
          const ruleMax = rule.maxValue ? rule.maxValue : 0

          if (valueForRuleCheck >= ruleMin && valueForRuleCheck < ruleMax) {
            //console.log(masterItem.visualizationDetails.visualizationRule)

            // Check if the rule has enums
            if (rule.enums && rule.enums.length > 0) {
              // Get the first enum from the rule (assuming one enum per rule)
              const enumValue = rule.enums[0].value
              //console.log('Found matching rule with enum value:', enumValue + ' - ' + getEnumVal(enumValue))
              return getEnumVal(enumValue).toLowerCase()
            }
          }
        }
      } else {
        // No master rules found, use individual item rules
        if (item?.visualizationDetails?.visualizationRule?.length > 0) {
          for (const rule of item.visualizationDetails.visualizationRule) {
            const ruleMin = rule.minValue ? rule.minValue : 0
            const ruleMax = rule.maxValue ? rule.maxValue : 0

            if (valueForRuleCheck >= ruleMin && valueForRuleCheck < ruleMax) {
              // Check if the rule has enums
              if (rule.enums && rule.enums.length > 0) {
                // Get the first enum from the rule (assuming one enum per rule)
                const enumValue = rule.enums[0].value
                //console.log('Found matching rule with enum value:', enumValue + ' - ' + getEnumVal(enumValue))
                return getEnumVal(enumValue).toLowerCase()
              }
            }
          }
        }
      }

      return false // Return false if no rules match or no rules exist
    }

    function getEnumVal(val) {
      return resolveEnum(val)
    }

    function shortenLabel(label) {
      const shortLabels = {
        Bedrijfsmannen: 'IMP',
        Voorzitters: 'COO',
        Vormgevers: 'SH',
        Uitvinders: 'PL',
        Brononderzoekers: 'RI',
        Waarschuwers: 'ME',
        Groupswerkers: 'TW',
        Afmakers: 'CF'
      }
      return shortLabels[label] || label
    }

    return {
      isAuthenticated,
      getCurrentUser,
      chartRef,
      isLoading,
      chartInstance,
      chartHeight,
      returnBelbinTableValueClass,
      returnClassBasedOnRules,
      getEnumVal,
      shortenLabel
    }
  }
})
</script>

<style lang="scss" scoped>
@import './index.scss';

.visualize-data {
  position: relative;
  width: 100%;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 10;
}

.unsupported-chart-type {
  padding: 20px;
  text-align: center;
  color: #666;
  background: #f5f5f5;
  border-radius: 8px;
}
</style>
